<template>
  <section class="landing landingbb purchase-sale">
    <div class="overlay">
      <div class="container">
        <div class="landing-content select-page-cat subpage-heading-center">
          <span class="mini-title">{{ $t('buyPage.miniTitle') }}</span>
          <span class="heading-title">{{ $t('buyPage.headingTitle') }}</span>
          <hr>
          <span class="paragraph">{{ $t('buyPage.paragraph') }}</span>
        </div>
        <div class="landing-content cards">
          <router-link :to="localizedPath('autoPurchase')" class="a-link-card">
            <div class="link-card">
              <div class="card-icon auto"></div>
              <span class="card-title">{{ $t('buyPage.cards.auto') }}</span>
            </div>
          </router-link>
          <router-link :to="localizedPath('motoPurchase')" class="a-link-card">
            <div class="link-card">
              <div class="card-icon moto"></div>
              <span class="card-title">{{ $t('buyPage.cards.moto') }}</span>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>


export default {
  name: 'PurchasePage',
  computed: {

    localizedPath() {
      return (routeKey) => {
        return this.$localizedPath(routeKey);
      };
    }
    // ✅ Computed property to always get the current route name

  },

};
</script>


<style scoped></style>